import generateTypes from '../../utils/generateTypes';

export const GET_ASSIGNED_POINTS = generateTypes('GET_ASSIGNED_POINTS');
export const RESET_ASSIGNED_POINTS = generateTypes('RESET_ASSIGNED_POINTS');
